<div class="bottom-menu" [ngClass]="[trajectoryService.active ? 'active' : '',  trajectoryService.fullScreenMode ? 'fullscreen' : '', menuController.open ? 'open-menu': '']">
  <div class="fields">
    <div class="close" (click)="cancelTrajectories()">
      <img src="/assets/img/close-white.svg" alt="" />
    </div>
    <div class="fullscreen-btn" (click)="trajectoryService.fullScreenMode = !trajectoryService.fullScreenMode"></div>

    <app-tabs></app-tabs>
    <div class="fields__container" [ngClass]="trajectoryService.fullScreenMode ? 'fullscreen' : ''">
    </div>
  </div>
</div>
